import React from 'react';
import Icon from '../../../components/AppIcon';

const KanbanColumn = ({ column, children, onDragOver, onDrop }) => {
  const getColorClasses = () => {
    const colors = {
      primary: 'bg-primary/10 border-primary/20 text-primary',
      secondary: 'bg-secondary/10 border-secondary/20 text-secondary',
      success: 'bg-success/10 border-success/20 text-success'
    };
    return colors?.[column?.color] || colors?.primary;
  };

  return (
    <div
      className="flex-shrink-0 w-80 bg-card rounded-2xl border border-border p-4"
      onDragOver={onDragOver}
      onDrop={onDrop}
    >
      {/* Column Header */}
      <div className={`flex items-center justify-between mb-4 p-3 rounded-xl border ${getColorClasses()}`}>
        <div className="flex items-center gap-2">
          <Icon name={column?.icon} size={20} />
          <h3 className="font-semibold text-foreground">{column?.title}</h3>
        </div>
        <span className="text-sm font-medium px-2 py-1 bg-background/50 rounded-lg">
          {column?.prospects?.length}
        </span>
      </div>

      {/* Column Content */}
      <div className="space-y-3 min-h-[400px]">
        {children?.length > 0 ? (
          children
        ) : (
          <div className="flex flex-col items-center justify-center py-12 text-center">
            <Icon name="Inbox" size={48} className="text-muted-foreground/30 mb-3" />
            <p className="text-sm text-muted-foreground">No prospects in this stage</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default KanbanColumn;